import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../Hooks/useAuth';

const mails = [
  'paulo.silva.ps2@vcimentos.com',
  'marcos.leite.ml1@vcimentos.com',
  'aline.natal.an1@vcimentos.com',
  'camila.nunes@vcimentos.com',
  'elisangela.forti@vcimentos.com',
  'daniel.seba@vcimentos.com',
  'rogerio.freitas@vcimentos.com',
  'katia.camargo@vcimentos.com',
  'thiago.sardinha@vcimentos.com',
  'camila.souza@vcimentos.com',
  'marcos.leite.ml1@vcimentos.com',
  'fabrine.morais@vcimentos.com',
  'patriciacpm@vcimentos.com',
  'vaness11@vcimentos.com',
  'daniela.lima.dl1@vcimentos.com',
  'luciana.caldas@vcimentos.com',
  'rodrigo.cardoso@vcimentos.com',
  'wendler.queirone@vcimentos.com',
  'elisangela.forti@vcimentos.com.br',
  'lucas.pazian@vcimentos.com',
  'mayra.contato@vcimentos.com',
  'michael.sousa@vcimentos.com',
  'pamelafc@vcimentos.com',
  'pamela.nogueira@vcimentos.com',
  'pamelafc@vcimentos.com',
  'pedro.almeida@vcimentos.com',
  'lucas.oliveira.lo6@vcimentos.com',
  'joao.silva.js5@vcimentos.com',
  'robert.silva.rs1@vcimentos.com',
  'andressa.mario@vcimentos.com',
  'lucas.miguel@vcimentos.com',
  'jessica.tricot@vcimentos.com',
  'drieli.pirola@vcimentos.com',
  'djefferson.brigido@vcimentos.com',
  'marina.machado@vcimentos.com',
  'leandro.lima.ll3@vcimentos.com',
  'clara.fonseca@vcimentos.com',
  'laio.souza@vcimentos.com',
  'jonatas.mesquita@vcimentos.com',
  'mariane.parro@vcimentos.com',
  'marina.mourao@vcimentos.com',
  'samara.cardozo.sc1@vcimentos.com',
  'robert.silva.rs1@vcimentos.com',
  'marina.machado@vcimentos.com',
  'rodrigo.sobreira@vcimentos.com',
  'yona.bento@vcimentos.com',
  'fabio.silva.fs5@vcimentos.com',
  'gabriel.moreira@vcimentos.com',
  'ingrid.pimenta@vcimentos.com',
  'jose.sousa.js8@vcimentos.com',
  'rep.marcos.alves@vcimentos.com',
  'denise.cavalcanti@vcimentos.com',
  'leandro.lima.ll3@vcimentos.com',
  'rep.jose.silva@vcimentos.com',
  'juliano.baeta@vcimentos.com',
  'artur.matias@vcimentos.com',
  'felipe.noll@vcimentos.com',
  'adriano.moraes@vcimentos.com',
  'aline.zanetti@vcimentos.com',
  'ana.fraguas@vcimentos.com',
  'ana.lima@vcimentos.com',
  'ana.violino@vcimentos.com',
  'andressa.silva.as3@vcimentos.com',
  'bianca.pontes@vcimentos.com',
  'carlos.figueredo@vcimentos.com',
  'carlos.lunkes@vcimentos.com',
  'cesar.luchesi@vcimentos.com',
  'claudio.barreto@vcimentos.com',
  'daiane.cassol@vcimentos.com',
  'debora.silva@vcimentos.com',
  'diego.lemos@vcimentos.com',
  'emanuela.formentini@vcimentos.com',
  'everson.bezerra@vcimentos.com',
  'everson.rocha@vcimentos.com',
  'felipe.morata@vcimentos.com',
  'felipe.merida@vcimentos.com',
  'flavia.schneider@vcimentos.com',
  'giordani.salamon@vcimentos.com',
  'giuseppe.giordano@vcimentos.com',
  'guilherme.meregalli@vcimentos.com',
  'herminio.pereira@vcimentos.com',
  'humberto.valle@vcimentos.com',
  'igor.reis@vcimentos.com',
  'joao.vedana@vcimentos.com',
  'joice.silva@vcimentos.com',
  'jonatas.carpes@vcimentos.com',
  'juliano.andrade@vcimentos.com',
  'julio.oliveira@vcimentos.com',
  'leandro.assis@vcimentos.com',
  'lincoln.pereira@vcimentos.com',
  'lucas.belo@vcimentos.com',
  'lucas.tieghi.lt1@vcimentos.com',
  'luciano.ferrari@vcimentos.com',
  'luciano.trindade@vcimentos.com',
  'luis.nascimento@vcimentos.com',
  'maiara.oliveira@vcimentos.com',
  'marcelo.baffi@vcimentos.com',
  'marcia.aguilar@vcimentos.com',
  'marco.pereira@vcimentos.com',
  'matheus.correa.mc2@vcimentos.com',
  'murilo.azevedo@vcimentos.com',
  'natalia.souza@vcimentos.com',
  'natalia.sousa@vcimentos.com',
  'natalianny.santos@vcimentos.com',
  'neyzon.araujo@vcimentos.com',
  'patrick.moura@vcimentos.com',
  'paulo.marcio@vcimentos.com',
  'paulo.nei@vcimentos.com',
  'paulo.monteiro@vcimentos.com',
  'rafael.barbosa@vcimentos.com',
  'rhaffael.soares@vcimentos.com',
  'roberta.felix@vcimentos.com',
  'rodrigo.amazonas@vcimentos.com',
  'ronaldo.silva.rs3@vcimentos.com',
  'rubens.netto@vcimentos.com',
  'thiago.mamore@vcimentos.com',
  'wagner.camilo@vcimentos.com',
];

function AuthSellerCPP({ children }) {
  const { user, account } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const isForbiddenEmail = account?.username && mails.includes(account.username.toLowerCase());
    if (!user || (account && isForbiddenEmail)) {
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontWeight: 'bold',
        }}
      >
        Você não tem acesso a esse recurso, entre em contato com o suporte caso tenha dúvidas.
      </div>;
    }
  }, [user, account, navigate]);

  const isForbiddenEmail = account?.username && mails.includes(account.username.toLowerCase());
  if (!user || (account && isForbiddenEmail)) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontWeight: 'bold',
        }}
      >
        Você não tem acesso a esse recurso, entre em contato com o suporte caso tenha dúvidas.
      </div>
    );
  }

  return children;
}

export default AuthSellerCPP;
